// import { genId } from "../../utils/formflow/helpers";

// export const initDB = { forms: [], submissions: [] };

// export function dbReducer(state, action) {
//     switch (action.type) {
//         case "SAVE_FORM": {
//             const exists = state.forms.some((f) => f.id === action.form.id);
//             return {
//                 ...state,
//                 forms: exists
//                     ? state.forms.map((f) => (f.id === action.form.id ? action.form : f))
//                     : [...state.forms, action.form],
//             };
//         }
//         case "DELETE_FORM":
//             return {
//                 ...state,
//                 forms: state.forms.filter((f) => f.id !== action.id),
//                 submissions: state.submissions.filter((s) => s.formId !== action.id),
//             };
//         case "SEND_FORM": {
//             const p = action.payload;
//             return {
//                 ...state,
//                 submissions: [
//                     ...state.submissions,
//                     {
//                         id: genId(),
//                         formId: p.formId,
//                         formName: p.formName,
//                         roles: p.roles,
//                         fields: p.fields,
//                         pdfName: p.pdfName,
//                         recipients: p.recipients.map((r) => ({
//                             ...r,
//                             id: genId(),
//                             status: "pending",
//                             submittedFields: {},
//                             submittedAt: null,
//                         })),
//                         sentAt: new Date().toISOString(),
//                         status: "sent",
//                     },
//                 ],
//             };
//         }
//         case "SUBMIT_FIELDS": {
//             return {
//                 ...state,
//                 submissions: state.submissions.map((sub) => {
//                     if (sub.id !== action.submissionId) return sub;
//                     const recs = sub.recipients.map((r) =>
//                         r.id !== action.recipientId
//                             ? r
//                             : {
//                                 ...r,
//                                 submittedFields: action.fields,
//                                 status: "completed",
//                                 submittedAt: new Date().toISOString(),
//                             }
//                     );
//                     return {
//                         ...sub,
//                         recipients: recs,
//                         status: recs.every((r) => r.status === "completed") ? "completed" : "in_progress",
//                     };
//                 }),
//             };
//         }
//         default:
//             return state;
//     }
// }





import { genId } from "../../utils/formflow/helpers";

export const initDB = { forms: [], submissions: [] };

export function dbReducer(state, action) {
    // Log all actions for debugging
    console.log(`[dbReducer] Action received: ${action.type}`, action);

    switch (action.type) {
        case "SAVE_FORM": {
            console.log(`[SAVE_FORM] Saving form:`, {
                id: action.form.id,
                name: action.form.name,
                fieldsCount: action.form.fields?.length,
                rolesCount: action.form.roles?.length,
                pdfName: action.form.pdfName
            });
            const exists = state.forms.some((f) => f.id === action.form.id);
            return {
                ...state,
                forms: exists
                    ? state.forms.map((f) => (f.id === action.form.id ? action.form : f))
                    : [...state.forms, action.form],
            };
        }
        case "DELETE_FORM": {
            console.log(`[DELETE_FORM] Deleting form with ID: ${action.id}`);
            console.log(`  - Forms count before: ${state.forms.length}`);
            console.log(`  - Submissions count before: ${state.submissions.length}`);
            return {
                ...state,
                forms: state.forms.filter((f) => f.id !== action.id),
                submissions: state.submissions.filter((s) => s.formId !== action.id),
            };
        }
        case "SEND_FORM": {
            const p = action.payload;
            console.log(`[SEND_FORM] Sending form:`, {
                formId: p.formId,
                formName: p.formName,
                recipientsCount: p.recipients?.length,
                rolesCount: p.roles?.length,
                fieldsCount: p.fields?.length,
                pdfName: p.pdfName
            });
            console.log(`  - Recipients details:`, p.recipients.map(r => ({ email: r.email, name: r.name })));
            const newSubmission = {
                id: genId(),
                formId: p.formId,
                formName: p.formName,
                roles: p.roles,
                fields: p.fields,
                pdfName: p.pdfName,
                recipients: p.recipients.map((r) => ({
                    ...r,
                    id: genId(),
                    status: "pending",
                    submittedFields: {},
                    submittedAt: null,
                })),
                sentAt: new Date().toISOString(),
                status: "sent",
            };
            console.log(`  - Created submission with ID: ${newSubmission.id}`);
            return {
                ...state,
                submissions: [...state.submissions, newSubmission],
            };
        }
        case "SUBMIT_FIELDS": {
            console.log(`[SUBMIT_FIELDS] Submitting fields for:`, {
                submissionId: action.submissionId,
                recipientId: action.recipientId,
                fields: action.fields
            });
            return {
                ...state,
                submissions: state.submissions.map((sub) => {
                    if (sub.id !== action.submissionId) return sub;
                    const recs = sub.recipients.map((r) =>
                        r.id !== action.recipientId
                            ? r
                            : {
                                ...r,
                                submittedFields: action.fields,
                                status: "completed",
                                submittedAt: new Date().toISOString(),
                            }
                    );
                    const newStatus = recs.every((r) => r.status === "completed") ? "completed" : "in_progress";
                    console.log(`  - Submission ${action.submissionId} new status: ${newStatus}`);
                    return {
                        ...sub,
                        recipients: recs,
                        status: newStatus,
                    };
                }),
            };
        }
        default:
            console.warn(`[dbReducer] Unknown action type: ${action.type}`);
            return state;
    }
}